/**
 * Link Widget
 *
 * Renders hyperlink from backend definition.
 */

import React from 'react';
import type { WidgetProps } from './registry';
import './Link.css';

export const LinkWidget: React.FC<WidgetProps> = ({ widget }) => {
  const { text, url, target = '_self', css_style } = widget;

  return (
    <div className="rul-widget-link" style={css_style}>
      <a
        href={url}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {text}
      </a>
    </div>
  );
};
